import { useState, useCallback } from 'react'
import { memo, NamedExoticComponent } from 'react'
import { Prescription } from '../../../types/models/Presc'
import { Box, Button, useTheme } from '@mui/material'
import { MenuIcon } from '../../../icons/MenuIcon'
import { MelphinDrawerPrescList } from '../components/MelphinDrawer'
import { useAppType } from '../../../contexts/AppTypeContext'

type Props = {
  selectedPresc?: Prescription
  PrescImageToggleButton: JSX.Element
  prescriptions: Prescription[]
  selectOcrRequest: (ocrRequestId: string) => void
  BottomButtons: React.ReactNode[]
}

export const MelphinDrawerToggleButton: NamedExoticComponent<Props> = memo(
  ({
    selectedPresc,
    PrescImageToggleButton,
    prescriptions,
    selectOcrRequest,
    BottomButtons,
  }) => {
    const [isOpen, setIsOpen] = useState(false)
    const theme = useTheme()
    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])

    const { config } = useAppType()
    const serviceName = config.serviceName

    return (
      <>
        <Box
          sx={{
            [theme.breakpoints.down('md')]: {
              bottom: '0',
              borderRadius: '0px 8px 0px 0px',
            },
            opacity: 0.8,
          }}
          position="fixed"
          zIndex={1300}
          left={0}
          bgcolor={'primary.dark'}
          color="#fff"
          p={1}
          borderRadius="0px 0px 8px 0px"
        >
          <Button
            onClick={open}
            startIcon={<MenuIcon />}
            style={{ color: '#fff' }}
          >
            {selectedPresc ? selectedPresc.label : serviceName}
          </Button>
        </Box>
        {PrescImageToggleButton}
        <MelphinDrawerPrescList
          isOpen={isOpen}
          onClose={close}
          prescriptions={prescriptions}
          selectedPresc={selectedPresc}
          selectOcrRequest={selectOcrRequest}
          BottomButtons={BottomButtons}
        />
      </>
    )
  }
)

MelphinDrawerToggleButton.displayName = 'MelphinDrawerToggleButton'
